export default __webpack_public_path__ + "static/media/imageb_parejas.ba44b095.png";